import { authRoles } from "./auth/authRoles";

export const navigations = [
  {
    name: "Аналитика",
    path: "/dashboard",
    icon: "dashboard",
    noChildren: true,
  },
  {
    name: "Показатели",
    icon: "assessment",
    children: [
      {
        name: "Поставки",
        path: "/store/invoices",
        icon: "assignment_returned",
      },
      {
        name: "Отгрузки",
        path: "/store/reserved",
        icon: "assignment_turned_in",
      },
      {
        name: "Платежи",
        path: "/documents/payment",
        icon: "monetization_on",
      },
    ]
  },
  {
    name: "Продажи",
    icon: "shop_two",
    children: [
      {
        name: "Заказ клиента",
        icon: "shopping_cart",
        path: "/documents/order",
        auth: authRoles.user,
      },
      {
        name: "Отгрузка",
        icon: "local_shipping",
        path: "/documents/shipment",
        auth: authRoles.user,
      },
    ],
  },
  {
    name: "Закупки",
    icon: "library_books",
    auth: authRoles.user,
    children: [
      {
        name: "Заказ поставщику",
        icon: "fire_truck",
        path: "/documents/invoice",
        auth: authRoles.user,
      },
      {
        name: "Приемка",
        icon: "forklift",
        path: "/documents/coming",
        auth: authRoles.user,
      },
    ],
  },
  {
    name: "Склад",
    icon: "library_add",
    auth: authRoles.user,
    children: [
      {
        name: "Остатки",
        path: "/store/stores",
        icon: "store",
      },
      {
        name: "Изделия",
        icon: "local_gas_station",
        path: "/manufacture/products",
        auth: authRoles.user,
      },
      {
        name: "Оприходование",
        icon: "add",
        path: "/documents/recording",
        auth: authRoles.user,
      },
      {
        name: "Списание",
        icon: "remove",
        path: "/documents/writedown",
        auth: authRoles.user,
      },
      {
        name: "Перемещение",
        icon: "exposure",
        path: "/documents/move",
        auth: authRoles.user,
      },
      {
        name: "Инвентаризация",
        icon: "storage",
        path: "/documents/inventory",
        auth: authRoles.user,
      },
      {
        name: "Комплектация",
        icon: "compare_arrows",
        path: "/documents/complectation",
        auth: authRoles.user,
      }
    ],
  },
  {
    name: "Производство",
    icon: "factory",
    children: [
      {
        name: "Заявки",
        icon: "factory",
        path: "/manufacture/items",
        auth: authRoles.user,
      },
      {
        name: "Спецификации",
        icon: "format_list_bulleted",
        path: "/manufacture/specifications",
        auth: authRoles.user,
      },
    ],
  },
  {
    name: "Справочники",
    icon: "auto_stories",
    auth: authRoles.user,
    children: [
      {
        name: "Номенклатура",
        icon: "extension",
        auth: authRoles.user,
        path: "/nomenclatures/list",
        // children: [
        //   {
        //     name: "Список",
        //     iconText: "Т",
        //     path: "/nomenclatures/list",
        //     auth: authRoles.user,
        //   },
        //   {
        //     name: "Категории",
        //     iconText: "К",
        //     path: "/nomenclatures/categories",
        //     auth: authRoles.user,
        //   },
        // ],
      },
      {
        name: "Контрагенты",
        icon: "work",
        auth: authRoles.user,
        path: "/contractors/list",
        // children: [
        //   {
        //     name: "Список контрагентов",
        //     iconText: "К",
        //     path: "/contractors/list",
        //     auth: authRoles.user,
        //   },
        //   {
        //     name: "Группы",
        //     iconText: "Г",
        //     path: "/contractors/groups",
        //     auth: authRoles.user,
        //   },
        // ],
      },
      // {
      //   name: "Договоры",
      //   iconText: "insert_drive_file",
      //   auth: authRoles.user,
      //   path: "/contracts/list",
      //   // children: [
      //   //   {
      //   //     name: "Список договоров",
      //   //     iconText: "Д",
      //   //     path: "/contracts/list",
      //   //     auth: authRoles.user,
      //   //   },
      //   //   {
      //   //     name: "Статусы",
      //   //     iconText: "С",
      //   //     path: "/contracts/statuses",
      //   //     auth: authRoles.user,
      //   //   },
      //   //   {
      //   //     name: "Типы",
      //   //     iconText: "Т",
      //   //     path: "/contracts/types",
      //   //     auth: authRoles.user,
      //   //   },
      //   // ],
      // },
      {
        name: "Общие",
        icon: "description",
        auth: authRoles.admin,
        children: [
          {
            name: "Организации",
            icon: "emoji_transportation",
            path: "/guides/organizations",
            auth: authRoles.admin,
          },
          {
            name: "Склады",
            icon: "home_work",
            path: "/guides/storages",
            auth: authRoles.admin,
          },
          {
            name: "Типы цен",
            icon: "money",
            path: "/guides/prices",
            auth: authRoles.admin,
          },
          {
            name: "Страны",
            icon: "flag",
            path: "/guides/countries",
            auth: authRoles.admin,
          },
          {
            name: "Единицы измерения",
            icon: "straighten",
            path: "/guides/units",
            auth: authRoles.admin,
          },
          {
            name: "Налоги",
            icon: "percent",
            path: "/guides/taxes",
            auth: authRoles.admin,
          },
          {
            name: "Валюты",
            icon: "currency_ruble",
            path: "/guides/currencies",
            auth: authRoles.admin,
          },
          {
            name: "Автонумерация",
            icon: "plus_one",
            path: "/guides/autonumbers",
            auth: authRoles.admin,
          },
        ],
      },
    ]
  },
  {
    name: "Администрирование",
    icon: "admin_panel_settings",
    auth: authRoles.admin,
    children: [
      {
        name: "Пользователи",
        path: "/users/list",
        icon: "people",
        auth: authRoles.admin,
      },
      {
        name: "Отделы",
        path: "/departments",
        icon: "tune",
        auth: authRoles.admin,
      },
      {
        name: "Настройки",
        path: "/admin/setting",
        icon: "settings",
        auth: authRoles.admin,
      },
      {
        name: "Логи",
        path: "/admin/logs",
        icon: "show_chart",
        auth: authRoles.admin,
      },
    ],
  },

];
